import { observer } from 'mobx-react';
import { autoinject, bind, FormStore, IFormField, inject, Input, toArray } from 'Mri.Web.Common';
import * as React from 'react';
import { ContractsStore } from '../../Contracts/ContractsStore';
import { NocServersStore } from '../../NocServers/NocServersStore';

export type FormFields =
    | 'cameraIP'
    | 'input1Ip'
    | 'player1pass'
    | 'dboardIp'
    | 'input2Ip'
    | 'player2pass'
    | 'dboardPort'
    | 'webport'
    | 'customer-display-id'
    | 'customer-display-id-2'
    | 'sslPort'
    | 'modemIp'
    | 'address1'
    | 'address2'
    | 'city'
    | 'state/province'
    | 'country'
    | 'postalCode'
    | 'siteId'
    | 'siteId2'
    | 'description'
    | 'comments';

export interface IImportFormRowProps {
    readonly formStore: FormStore<Mri.Web.Internal.Controllers.Displays.UpdateDisplayModel>;
    readonly columns: string[];
    readonly emptyColumns: string[];
    readonly serialNumber: string;
}

@autoinject
@observer
export class ImportFormRow extends React.Component<IImportFormRowProps> {
    public render() {
        return (
            <tr>
                {this.props.columns.includes('SerialNumber') && <td className="py-2">{this.props.serialNumber}</td>}

                {this.props.columns.includes('CameraIP') && (
                    <td>
                        <Input
                            type="text"
                            field={this.props.formStore.fields.displayConnectionData.fields.cameraIP}
                            id="camerIP"
                            className={this.getInputClass(
                                'CameraIP',
                                this.props.formStore.fields.displayConnectionData.fields.cameraIP
                            )}
                        />
                    </td>
                )}

                {this.props.columns.includes('Active') && (
                    <td>
                        <Input
                            type="checkbox"
                            field={this.props.formStore.fields.displayConnectionData.fields.active}
                            id="active"
                            className="mx-1"
                        />
                    </td>
                )}

                {this.props.columns.includes('Input1IP') && (
                    <td>
                        <Input
                            type="text"
                            field={this.props.formStore.fields.displayConnectionData.fields.input1IP}
                            id="input1IP"
                            className={this.getInputClass(
                                'Input1IP',
                                this.props.formStore.fields.displayConnectionData.fields.input1IP
                            )}
                            placeholder=""
                        />
                    </td>
                )}

                {this.props.columns.includes('Input1Password') && (
                    <td>
                        <Input
                            type="text"
                            field={this.props.formStore.fields.displayConnectionData.fields.input1Password}
                            id="i1pass"
                            className={this.getInputClass(
                                'Input1Password',
                                this.props.formStore.fields.displayConnectionData.fields.input1Password
                            )}
                        />
                    </td>
                )}

                {this.props.columns.includes('Input2IP') && (
                    <td>
                        <Input
                            type="text"
                            field={this.props.formStore.fields.displayConnectionData.fields.input2IP}
                            id="input2ip"
                            className={this.getInputClass(
                                'Input2IP',
                                this.props.formStore.fields.displayConnectionData.fields.input2IP
                            )}
                            placeholder=""
                        />
                    </td>
                )}

                {this.props.columns.includes('Input2Password') && (
                    <td>
                        <Input
                            type="text"
                            field={this.props.formStore.fields.displayConnectionData.fields.input2Password}
                            id="i2pass"
                            className={this.getInputClass(
                                'Input2Password',
                                this.props.formStore.fields.displayConnectionData.fields.input2Password
                            )}
                        />
                    </td>
                )}

                {this.props.columns.includes('DisplayBoardIP') && (
                    <td>
                        <Input
                            type="text"
                            field={this.props.formStore.fields.displayConnectionData.fields.displayBoardIP}
                            id="dbIP"
                            className={this.getInputClass(
                                'DisplayBoardIP',
                                this.props.formStore.fields.displayConnectionData.fields.displayBoardIP
                            )}
                        />
                    </td>
                )}

                {this.props.columns.includes('DisplayBoardPort') && (
                    <td>
                        <Input
                            type="number"
                            field={this.props.formStore.fields.displayConnectionData.fields.displayBoardPort}
                            id="dbPort"
                            className={this.getInputClass(
                                'DisplayBoardPort',
                                this.props.formStore.fields.displayConnectionData.fields.displayBoardPort
                            )}
                        />
                    </td>
                )}

                {this.props.columns.includes('DisplayBoardWebsitePort') && (
                    <td>
                        <Input
                            type="number"
                            field={this.props.formStore.fields.displayConnectionData.fields.displayBoardWebsitePort}
                            id="websitePort"
                            className={this.getInputClass(
                                'DisplayBoardWebsitePort',
                                this.props.formStore.fields.displayConnectionData.fields.displayBoardWebsitePort
                            )}
                        />
                    </td>
                )}

                {this.props.columns.includes('NocServer') && (
                    <td>
                        <Input
                            type="select"
                            field={this.props.formStore.fields.displayConnectionData.fields.nocServer}
                            id="nocserver"
                            className={this.getInputClass(
                                'NocServer',
                                this.props.formStore.fields.displayConnectionData.fields.nocServer
                            )}
                        >
                            <option value="" disabled>
                                -
                            </option>
                            {toArray(this.nocServersStore.nocServers).map(n => (
                                <option key={n.serverName}>{n.serverName}</option>
                            ))}
                        </Input>
                    </td>
                )}

                {this.props.columns.includes('Contract') && (
                    <td>
                        <Input
                            type="select"
                            field={this.props.formStore.fields.contract}
                            id="contract"
                            className={this.getInputClass('Contract', this.props.formStore.fields.contract)}
                        >
                            <option value="" disabled>
                                -
                            </option>
                            {toArray(this.contractsStore.contracts).map(c => (
                                <option key={c.serviceCO}>{c.serviceCO}</option>
                            ))}
                        </Input>
                    </td>
                )}

                {this.props.columns.includes('CustomerSiteID') && (
                    <td>
                        <Input
                            type="text"
                            field={this.props.formStore.fields.unitLocation.fields.customerSiteID}
                            id="csid"
                            className={this.getInputClass(
                                'CustomerSiteID',
                                this.props.formStore.fields.unitLocation.fields.customerSiteID
                            )}
                        />
                    </td>
                )}

                {this.props.columns.includes('CustomerSiteID2') && (
                    <td>
                        <Input
                            type="text"
                            field={this.props.formStore.fields.unitLocation.fields.customerSiteID2}
                            id="csid2"
                            className={this.getInputClass(
                                'CustomerSiteID2',
                                this.props.formStore.fields.unitLocation.fields.customerSiteID2
                            )}
                        />
                    </td>
                )}

                {this.props.columns.includes('CustomerDisplayID') && (
                    <td>
                        <Input
                            type="text"
                            field={this.props.formStore.fields.displayConnectionData.fields.customerDisplayID}
                            id="cdid"
                            className={this.getInputClass(
                                'Comments',
                                this.props.formStore.fields.displayConnectionData.fields.comments
                            )}
                        />
                    </td>
                )}

                {this.props.columns.includes('CustomerDisplayID2') && (
                    <td>
                        <Input
                            type="text"
                            field={this.props.formStore.fields.displayConnectionData.fields.customerDisplayID2}
                            id="cdid2"
                            className={this.getInputClass(
                                'CustomerDisplayID2',
                                this.props.formStore.fields.displayConnectionData.fields.customerDisplayID2
                            )}
                        />
                    </td>
                )}

                {this.props.columns.includes('SslPort') && (
                    <td>
                        <Input
                            type="number"
                            field={this.props.formStore.fields.displayConnectionData.fields.sslPort}
                            id="sslport"
                            className={this.getInputClass(
                                'SslPort',
                                this.props.formStore.fields.displayConnectionData.fields.sslPort
                            )}
                        />
                    </td>
                )}

                {this.props.columns.includes('ModemIP') && (
                    <td>
                        <Input
                            type="text"
                            field={this.props.formStore.fields.displayConnectionData.fields.modemIP}
                            id="momdemip"
                            className={this.getInputClass(
                                'ModemIP',
                                this.props.formStore.fields.displayConnectionData.fields.modemIP
                            )}
                        />
                    </td>
                )}

                {this.props.columns.includes('Address1') && (
                    <td>
                        <Input
                            type="text"
                            field={this.props.formStore.fields.unitLocation.fields.address1}
                            id="address1"
                            className={this.getInputClass(
                                'Address1',
                                this.props.formStore.fields.unitLocation.fields.address1
                            )}
                        />
                    </td>
                )}

                {this.props.columns.includes('Address2') && (
                    <td>
                        <Input
                            type="text"
                            field={this.props.formStore.fields.unitLocation.fields.address2}
                            id="address2"
                            className={this.getInputClass(
                                'Address2',
                                this.props.formStore.fields.unitLocation.fields.address2
                            )}
                        />
                    </td>
                )}

                {this.props.columns.includes('City') && (
                    <td>
                        <Input
                            type="text"
                            field={this.props.formStore.fields.unitLocation.fields.city}
                            id="city"
                            className={this.getInputClass('City', this.props.formStore.fields.unitLocation.fields.city)}
                        />
                    </td>
                )}

                {this.props.columns.includes('StateOrProvince') && (
                    <td>
                        <Input
                            type="text"
                            field={this.props.formStore.fields.unitLocation.fields.stateOrProvince}
                            id="state"
                            className={this.getInputClass(
                                'StateOrProvince',
                                this.props.formStore.fields.unitLocation.fields.stateOrProvince
                            )}
                        />
                    </td>
                )}

                {this.props.columns.includes('Country') && (
                    <td>
                        <Input
                            type="text"
                            field={this.props.formStore.fields.unitLocation.fields.country}
                            id="country"
                            className={this.getInputClass(
                                'Country',
                                this.props.formStore.fields.unitLocation.fields.country
                            )}
                        />
                    </td>
                )}

                {this.props.columns.includes('PostalCode') && (
                    <td>
                        <Input
                            type="text"
                            field={this.props.formStore.fields.unitLocation.fields.postalCode}
                            id="postalCode"
                            className={this.getInputClass(
                                'PostalCode',
                                this.props.formStore.fields.unitLocation.fields.postalCode
                            )}
                        />
                    </td>
                )}

                {this.props.columns.includes('Description') && (
                    <td>
                        <Input
                            type="text"
                            field={this.props.formStore.fields.unitLocation.fields.description}
                            id="description"
                            className={this.getInputClass(
                                'Description',
                                this.props.formStore.fields.unitLocation.fields.description
                            )}
                        />
                    </td>
                )}

                {this.props.columns.includes('Comments') && (
                    <td>
                        <Input
                            type="text"
                            field={this.props.formStore.fields.displayConnectionData.fields.comments}
                            id="comments"
                            className={this.getInputClass(
                                'Comments',
                                this.props.formStore.fields.displayConnectionData.fields.comments
                            )}
                        />
                    </td>
                )}
            </tr>
        );
    }

    @bind
    private getInputClass(column: string, field: IFormField<string | number | undefined | null>) {
        if (this.props.emptyColumns.includes(column) && !field.value) {
            return 'text-form yellow-border';
        }

        return 'text-form';
    }

    @inject
    private contractsStore!: ContractsStore;
    @inject
    private nocServersStore!: NocServersStore;
}
